<div class="api-reseller-pro" [ngClass]="{'db-dialog': fromDialog}">
    <div class="plans-container">
      @if (this.currentSubscription?.hostingTrialExpired) {
          <h2 class="mb8">{{'text_upgradeToContinue' | dbText: {companyName: companyName} }}</h2>
      } @else {
          <h2 class="mb8">{{'text_companyPlans' | dbText: {companyName: companyName} }}</h2>
      }
        <div class="desc"
             [innerHTML]="'text_upgradePlanDescription' | dbText"></div>

      <div class="plans-controls mt32">
          @if (showPeriodSwitcher) {
              <div class="db-pricing-period-switcher-wrapper">
                  <db-pricing-period-switcher
                          [user]="user"
                          [isApiReseller]="true"
                          [currentSubscription]="currentSubscription"
                          [value]="periodSwitch"
                          (valueChange)="onPeriodSwitchChange($event)">
                  </db-pricing-period-switcher>
              </div>
          } @else {
              <span></span>
          }
          @if (subscriptions?.length > 3) {
              <div class="carousel-buttons">
                  <button class="carousel-btn" (click)="slideLeft()" [disabled]="currentSlide === 0">
                      <i class="db-icon db-icon-ds-single-arrow-small carousel-icon-left"></i>
                  </button>
                  <button class="carousel-btn" (click)="slideRight()" [disabled]="currentSlide === totalSlides - 1">
                      <i class="db-icon db-icon-ds-single-arrow-small"></i>
                  </button>
              </div>
          }
      </div>
  </div>
    <div class="plans-outer mt32">
        <div class="plans-wrap" #plansContainer (scroll)="onPlansScroll()">
        <div class="plan-plans-container">
            @for (plan of subscriptions; track $index) {
                <ng-container>
                    <div class="plan-item {{plan?.category}}">
                        <div class="plan-item-header">
                            <div class="plan-item-title-container">
                                <h3>{{ plan?.title }}</h3>
                                @if(plan?.discountPercent && plan?.plan?.periodNumber === 12){
                                    <span class="discount">{{ plan?.discountPercent | DbNumberParseFloatPipe }}% off</span>
                                }
                            </div>

                            <div class="plan-item-price">
                                <ng-container *ngIf="isCurrencyBeforeAmount">
                                    {{ currencySymbol }}{{ plan?.plan?.periodNumber === 1 ? plan?.plan?.planPrice : plan?.plan?.planPrice/12  | DbNumberFormatPipe: 'ceil' }}
                                </ng-container>
                                <ng-container *ngIf="!isCurrencyBeforeAmount">
                                    {{ plan?.plan?.periodNumber === 1 ? plan?.plan?.planPrice : plan?.plan?.planPrice/12  | DbNumberFormatPipe: 'ceil' }} {{ currencySymbol }}
                                </ng-container>
                                <span>/{{ 'text_mo' | dbText}}</span>
                            </div>
                            <div class="db-billed"
                                 [class.line-through]="plan?.discountPercent">
                                <ng-container *ngIf="plan?.plan?.periodNumber === 12">
                                    <ng-container *ngIf="plan?.discountPercent">
                                        <ng-container *ngIf="isCurrencyBeforeAmount">
                                            {{ currencySymbol }}{{ plan?.monthlyPrice }} monthly price
                                        </ng-container>
                                        <ng-container *ngIf="!isCurrencyBeforeAmount">
                                            {{ plan?.monthlyPrice }} {{ currencySymbol }} monthly price
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="!plan?.discountPercent">
                                        {{ 'text_billedAnnually' | dbText}}
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="plan?.plan?.periodNumber !== 12">
                                    {{ 'text_billedMonthly' | dbText}}
                                </ng-container>
                            </div>

                            @if(plan?.subscriptionId === currentSubscription?.subscriptionId){
                                <button class="ds-btn-gray ds-btn-max current mt24">
                                    <span>{{ 'text_currentPlan' | dbText}}</span>
                                </button>
                            } @else if(plan?.plan?.periodNumber === 12 && plan?.id === currentSubscription?.id) {
                                <a (click)="chooseSubscription(plan?.plan?.agency_pricing_plan_id)"
                                    class="ds-btn-black ds-btn-max mt24"><span>{{ 'text_switchToAnnual' | dbText}}</span></a>
                            }@else {
                                <a (click)="chooseSubscription(plan?.plan?.agency_pricing_plan_id)"
                                    class="ds-btn-black ds-btn-max mt24"><span>{{ 'text_upgrade' | dbText }}</span></a>
                            }

                            @if (plan?.plan?.periodNumber === 12) {
                                <p class="plan-item-annual-hint mt16">
                                    <ng-container *ngIf="isCurrencyBeforeAmount">Get 12 months for {{ currencySymbol }}{{ plan?.plan?.planPrice | DbNumberFormatPipe: 'ceil' }}</ng-container>
                                    <ng-container *ngIf="!isCurrencyBeforeAmount">Get 12 months for {{ plan?.plan?.planPrice | DbNumberFormatPipe: 'ceil' }} {{ currencySymbol }}</ng-container>
                                    @if (plan?.discountPercent) {
                                        <br>
                                        <ng-container *ngIf="isCurrencyBeforeAmount">(regular price {{ currencySymbol }}{{ plan?.monthlyPrice * 12 | DbNumberFormatPipe: 'ceil' }}).</ng-container>
                                        <ng-container *ngIf="!isCurrencyBeforeAmount">(regular price {{ plan?.monthlyPrice * 12 | DbNumberFormatPipe: 'ceil' }} {{ currencySymbol }}).</ng-container>
                                    }
                                </p>
                            }

                            @if (plan?.primaryFeatures?.length) {
                                <div class="plan-item-subscription-features">
                                    @for (feature of plan?.primaryFeatures; track $index) {
                                        <div class="plan-item-subscription-feature">
                                            <div class="plan-item-subscription-feature-left">
                                                <i class="db-icon"
                                                   [ngClass]="feature?.slug === 'tenweb_hosting' ? 'db-icon-ds-sidebar-domain' : 'db-icon-vc-generate-ai'"></i>
                                                <span>{{ feature?.slug === 'tenweb_hosting' ? 'Websites' : 'AI credits' }}</span>
                                            </div>
                                            <span class="plan-item-feature-badge">{{ feature?.value }}{{ feature?.slug === 'monthly_credit_limit' ? '/mo' : '' }}</span>
                                        </div>
                                    }
                                </div>
                            }

    <!--                            @if (plan?.storageFeatures?.length) {
                                <div class="plan-item-storage-features">
                                    @for (feature of plan?.storageFeatures; track $index) {
                                        <div class="plan-item-storage-feature">
                                            <span>{{ feature?.slug === 'ssd' ? 'SSD storage' : 'Monthly visitors' }}</span>
                                            <span class="plan-item-feature-badge">{{ feature?.value }}</span>
                                        </div>
                                    }
                                </div>
                            }-->

                            @if (plan?.additionalFeatures?.length) {
                                <div class="plan-item-main-features">
                                    @for (feature of plan?.additionalFeatures; track $index) {
                                        <div class="plan-item-main-feature">
                                            <i class="db-icon db-icon-ds-checkmark"></i>
                                            @if (feature?.slug === 'allow_woocommerce_service') {
                                                <span>Ecommerce</span>
                                            } @else {
                                                <span>{{ feature?.value ?? '' }} {{ feature?.value ? feature?.title?.replace('limit', '')?.replace('Limit', '') : feature?.title?.replace('limit', '')?.replace('Limit', '') }}</span>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </ng-container>
            }
        </div>
        </div>
        @if (!isMobile && subscriptions?.length < 4) {
            <div class="plans-gradient-left" [class.visible]="showLeftGradient"></div>
            <div class="plans-gradient-right" [class.hidden]="!showRightGradient"></div>
        }
    </div>
    @if (subscriptions?.length > 3) {
        <div class="carousel-dots">
            @for (i of totalSlidesArray; track i) {
                <span class="carousel-dot" [class.active]="i === currentSlide" (click)="slideTo(i)"></span>
            }
        </div>
    }
</div>
